import { createDrawer } from '../../legacy/overlay.js';

/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data:{
       circle_id:0,
       locked:false,
    },
    mounted(){
        if(typeof qk_circle !== 'undefined') {
            this.circle_id = qk_circle.id;
        }
    },
    methods:{
        seeInfo(){
            createDrawer({componentName:'circleManage'})
        },
        joinCircle(){
            if(!qktoken) return this.$createModal('login')
            createModal('joinCircle')
        }
    }
};
